// Список причин жалобы. Значения value совпадают с COMPLAIN_REASONS на сервере
// (server/controllers/complain/complain.js). Последняя причина — «Другое»,
// для неё пользователь пишет свой текст в reasonText.

export const COMPLAIN_OTHER_ID = 11;

// Минимальная длина свободного текста причины (совпадает с проверкой в модалке).
export const COMPLAIN_TEXT_MIN_LENGTH = 5;

export const complainReasons = [
    { value: 1, name: 'Спам или реклама' },
    { value: 2, name: 'Оскорбления или травля' },
    { value: 3, name: 'Насилие или угрозы' },
    { value: 4, name: 'Порнография или контент 18+' },
    { value: 5, name: 'Разжигание ненависти или дискриминация' },
    { value: 6, name: 'Мошенничество или обман' },
    { value: 7, name: 'Нарушение авторских прав' },
    { value: 8, name: 'Контент о самоповреждении или суициде' },
    { value: 9, name: 'Продажа запрещённых товаров (оружие, наркотики)' },
    { value: 10, name: 'Дезинформация' },
    { value: COMPLAIN_OTHER_ID, name: 'Другое' },
];
